import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Provider, useInjection } from '@core/providers/inversify-react.provider'
import { container } from '@core/ioc/container.app'
import { AppPresenter } from './app.presenter'
import { AppLayoutComponent } from '@app/layout/app-layout.component'
import { ErrorBoundaryComponent } from '@app/layout/error-boundary.component'
import { routeComponents } from '@app/routes'

const AppRoot = observer(function AppRoot() {
  const presenter: AppPresenter = useInjection(AppPresenter)

  useEffect(() => {
    presenter.load(() => {})
  }, [presenter])

  return <AppLayoutComponent routeComponents={routeComponents} />
})

export const App = () => (
  <ErrorBoundaryComponent>
    <Provider container={container}>
      <AppRoot />
    </Provider>
  </ErrorBoundaryComponent>
)
